// src/Layout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';

const Layout = ({
  username,
  userBalance,
  onLogout,
  userAvatar,
  userAssets = { tickets: [], skins: [] }
}) => {
  return (
    <>
      <Header
        username={username}
        userBalance={userBalance}
        onLogout={onLogout}
        userAvatar={userAvatar}
        userAssets={userAssets}
      />

      <Outlet />
    </>
  );
};

export default Layout;